<template>
  <section class="section">
    <div class="glass-container animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Usuarios</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Administradores y personal con acceso al panel</p>
          </div>
        </div>
        <div class="level-right">
          <b-button 
            type="is-primary" 
            icon-left="account-plus" 
            class="is-rounded glass-btn"
            size="is-medium"
            @click="agregarUsuario"
          >
            Nuevo Usuario
          </b-button>
        </div>
      </div>

      <div class="table-container glass-table">
        <b-table 
          :data="usuarios" 
          :hoverable="true" 
          :loading="cargando"
          mobile-cards
        >
          <b-table-column field="usuario" label="Usuario" v-slot="props">
            <div class="is-flex is-align-items-center">
              <b-icon icon="account-key-outline" class="mr-2 has-text-primary" size="is-small" />
              <span class="has-text-weight-bold">{{ props.row.usuario }}</span>
            </div>
          </b-table-column>

          <b-table-column field="nombre" label="Nombre Completo" v-slot="props">
            {{ props.row.nombre }}
          </b-table-column>

          <b-table-column field="telefono" label="Teléfono" v-slot="props">
            <b-tag type="is-info is-light" class="is-rounded glass-tag-info">{{ props.row.telefono }}</b-tag>
          </b-table-column>

          <b-table-column field="acciones" label="Acciones" v-slot="props" centered>
            <div class="buttons is-centered">
              <b-button
                type="is-info"
                size="is-small"
                icon-left="pencil"
                class="is-rounded glass-action"
                @click="editar(props.row.id)"
              >
                Editar
              </b-button>
              <b-button
                type="is-danger"
                size="is-small"
                icon-left="trash-can"
                class="is-rounded glass-action-danger"
                @click="eliminar(props.row.id)"
              >
                Eliminar
              </b-button>
            </div>
          </b-table-column>

          <template #empty>
            <div class="has-text-centered py-6">
              <b-icon icon="account-off" size="is-large" class="has-text-grey-light"></b-icon>
              <p class="has-text-grey mt-2">No hay usuarios registrados.</p>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
import HttpService from '../../Servicios/HttpService';
import Swal from 'sweetalert2';

export default {
  name: "UsuariosComponent",
  data() {
    return {
      cargando: false,
      usuarios: []
    };
  },
  mounted() {
    this.obtenerUsuarios();
    document.title = 'Metropolitan - Usuarios';
  },
  methods: {
    agregarUsuario() {
      this.$router.push({ path: '/agregar-usuario' });
    },
    editar(idUsuario) {
      this.$router.push({
        name: "EditarUsuario",
        params: { id: idUsuario }
      });
    },
    obtenerUsuarios() {
      this.cargando = true;
      HttpService.obtenerConConsultas('usuarios.php', { accion: 'obtener' })
        .then(usuarios => {
          this.usuarios = usuarios || [];
          this.cargando = false;
        });
    },
    eliminar(idUsuario) {
      Swal.fire({
        title: '¿Eliminar usuario?',
        text: 'Esta acción desactivará el acceso para esta cuenta',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        background: '#1e293b',
        color: '#fff'
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargando = true;
          HttpService.eliminar('usuarios.php', { accion: 'eliminar', id: idUsuario })
            .then(res => {
              this.cargando = false;
              if (res) {
                Swal.fire({ icon: 'success', title: 'Borrado', timer: 1500, showConfirmButton: false });
                this.obtenerUsuarios();
              }
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.glass-container {
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  min-height: 80vh;
}

.glass-table /deep/ .table {
  background: transparent !important;
  color: white !important;
}

.glass-table /deep/ .table thead th {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #3b82f6 !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  padding: 15px;
}

.glass-table /deep/ .table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.9);
  padding: 15px;
}

.glass-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.2);
}

.glass-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.3);
}

.glass-action {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #94a3b8 !important;
  transition: all 0.3s ease;
}

.glass-action:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
}

.glass-action-danger {
  background: rgba(239, 68, 68, 0.1) !important;
  border: 1px solid rgba(239, 68, 68, 0.3) !important;
  color: #f87171 !important;
}

.glass-tag-info {
  background: rgba(59, 130, 246, 0.1) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  color: #60a5fa !important;
}

::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }

@media screen and (max-width: 768px) {
  .section { padding: 15px 10px; }
  .glass-container { padding: 20px; }
}
</style>
